module.exports = __webpack_public_path__ + "static/media/ByPassBN_blur.fb17538b.jpg";